import { useEffect, useState } from 'react'

import { sessionService } from './sessionService'

export type SessionStatus = 'pending' | 'ready' | 'error'

/**
 * Инициализирует сессию при монтировании оверлея:
 *  - обменивает bootstrap-токен из URL на cookie,
 *  - загружает публичный ключ Ed25519 в pluginVerifier.
 *
 * Пока статус 'pending' — WS-соединение открывать не нужно.
 * 'error' — сессию установить не удалось (нет токена/ключа); оверлей
 * покажет соответствующее состояние, но это не фатально для рендера.
 */
export function useSessionBootstrap(): SessionStatus {
  const [status, setStatus] = useState<SessionStatus>('pending')

  useEffect(() => {
    let cancelled = false
    sessionService
      .bootstrap()
      .then((ok) => {
        if (!cancelled) setStatus(ok ? 'ready' : 'error')
      })
      .catch(() => {
        if (!cancelled) setStatus('error')
      })
    return () => {
      cancelled = true
    }
  }, [])

  return status
}
